<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        General.PROCESS_NEW_ACTIONS
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="close()">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="timeline-container">
        <div
          v-for="(item, index) in history"
          :key="index"
          class="timeline spacing-ml-20"
          statusColor="green-light"
        >
          <div class="timeline-tag">
            <div class="timeline-badge">
              <b-icon
                icon="checkbox-blank-circle-outline"
                :type="isContrast ? 'is-white-dark' : 'is-green-light'"
              />
            </div>
            <div
              v-if="index != history.length - 1"
              data-v-67275acf=""
              class="progress-line"
            ></div>
          </div>
          <div class="timeline-panel">
            <div class="is-size-6">
              <span class="has-text-color-7">
                {{ new Date(item.date) | dateFormat("DD/MM/YYYY") }} às
                {{ new Date(item.date) | dateFormat("HH:mm:ss") }}</span
              >
              <span class="has-text-color-7">
                {{ item.document_name }} - {{ item.user_name }}
                {{ item.status || item.text }}
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { General } from "@/utils/constants";

export default {
  name: "MOdalNewsDetail",

  props: {
    history: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      General,
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    })
  },

  methods: {
    close() {
      this.$parent.cancel();
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.timeline-panel {
  padding-left: 0;
  padding-top: 2px;
}

.timeline-badge {
  background-color: transparent !important;
}

.modal-card {
  display: flex;
  justify-content: space-between;
  min-width: 50vw;
  max-height: 75vh;
  background-color: $color-1;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}
</style>
